import { isMale, isFemale } from '../../shared/helpers/gedcom_X'

const determineChild = (state) => {
  if (!state || !state.anchorATN || state.anchorATN < 4) {
    return null
  }
  const desiredAtn = Math.floor(state.anchorATN / 2)
  const directDescendent = state.userTree[desiredAtn]
  return directDescendent
}

const determineChildByAtn = (state, atn) => {
  if (!state || !atn) {
    return null
  }
  const desiredAtn = Math.floor(atn / 2)
  const directDescendent = state.userTree[desiredAtn]
  return directDescendent
}

const determineSpouse = ({ state, atn }) => {
  if (!state || !atn || atn === 1) {
    return null
  }

  const lookups = [{ 2: 3 }, { 3: 2 }, { 4: 5 }, { 5: 4 }, { 6: 7 }, { 7: 6 }]

  const targetAtn = lookups.find((item) => item[atn])
  return state.userTree[targetAtn[atn]]
}

const determineAncestorReferenceLabel = (atn, genderType) => {
  const isMe = atn === 1
  const isParent = atn < 4

  if (isMe) {
    return { key: 'atf.base-tree.user', defaultValue: 'Me' }
  }

  if (isParent) {
    return isMale(genderType)
      ? { key: 'atf.base-tree.dad', defaultValue: 'Father' }
      : { key: 'atf.base-tree.mom', defaultValue: 'Mother' }
  }

  return isMale(genderType)
    ? { key: 'atf.base-tree.mothers-father', defaultValue: 'Grandfather' }
    : { key: 'atf.base-tree.mothers-mother', defaultValue: 'Grandmother' }
}

const determineGrandparentOwnershipLables = (genderType, childGenderType) => {
  const isChildMale = isMale(childGenderType)
  const isChildFemale = isFemale(childGenderType)
  const isParentMale = isMale(genderType)
  const isParentFemale = isFemale(genderType)

  if (isChildMale) {
    if (isParentMale) {
      return { key: 'atf.ancestor-editor.dads-dad', defaultValue: "Your dad's father." }
    }
    if (isParentFemale) {
      return { key: 'atf.ancestor-editor.dads-mom', defaultValue: "Your dad's mother." }
    }
    return { key: 'atf.ancestor-editor.unknown-dad', defaultValue: "Your dads's father." }
  }
  if (isChildFemale) {
    if (isParentMale) {
      return { key: 'atf.ancestor-editor.moms-dad', defaultValue: "Your mom's father." }
    }
    if (isParentFemale) {
      return { key: 'atf.ancestor-editor.moms-mom', defaultValue: "Your mom's mother." }
    }
    return { key: 'atf.ancestor-editor.unkMom', defaultValue: "Your mom's parent." }
  }

  if (isParentMale) {
    return { key: 'atf.ancestor-editor.unknown-dad', defaultValue: "Your ancestor's father." }
  }
  if (isParentFemale) {
    return { key: 'atf.ancestor-editor.unkMom', defaultValue: "Your ancestor's mother." }
  }

  return { key: 'atf.AncestorEditor.unkParent', defaultValue: "Your ancestor's parent." }
}

const determineParentOwnership = (genderType) => {
  if (isMale(genderType)) {
    return { key: 'atf.ancestor-editor.dad', defaultValue: 'Your dad.' }
  }
  if (isFemale(genderType)) {
    return { key: 'atf.ancestor-editor.mom', defaultValue: 'Your mom.' }
  }

  return { key: 'atf.ancestor-editor.parent', defaultValue: 'Your parent.' }
}

const determineAncestorOwnershipLabels = (personObj, child, genderType) => {
  const isGrandparent = personObj.atn > 3
  const isParent = personObj.atn > 1 && personObj.atn <= 3

  if (isGrandparent && child) {
    return determineGrandparentOwnershipLables(genderType, child.genderType)
  }

  if (isParent) {
    return determineParentOwnership(genderType)
  }

  return { key: 'atf.AncestorEditor.you', defaultValue: 'You.' }
}

const determineFormLabelsByGenderType = (t, genderType) => {
  const details = {
    placeholderFirstName: t('atf.ancestor-editor.labels.first-name', 'First name'),
    placeholderSurname: t('atf.ancestor-editor.labels.last-name', 'Last name'),
    labelSurname: t('atf.ancestor-editor.labels.last-name', 'Last Name'),
    maidenInfo: isFemale(genderType)
      ? t(
          'atf.ancestor-editor.maiden-name-info',
          'A maiden name is her name before she was married. You might need to ask her what her maiden name is.'
        )
      : null,
  }

  if (isMale(genderType)) {
    details.placeholderFirstName = t('atf.ancestor-editor.placeholders.male-first-name', 'His first name')
    details.placeholderSurname = t('atf.ancestor-editor.placeholders.last-name', 'His last name')
  } else if (isFemale(genderType)) {
    details.placeholderFirstName = t('atf.ancestor-editor.placeholders.female-first-name', 'Her first name')
    details.placeholderSurname = t('atf.ancestor-editor.placeholders.maiden-name', 'Her maiden name')
    details.labelSurname = t('atf.ancestor-editor.labels.maiden-name', 'Maiden Name')
  }

  return details
}

const determineRelationshipLevel = (atn) => {
  let relation
  if (atn === 1) {
    relation = 'immediate'
  } else if (atn === 2 || atn === 3) {
    relation = 'parent'
  } else if (atn === 4 || atn === 5 || atn === 6 || atn === 7) {
    relation = 'grandparent'
  }
  return relation
}

export {
  determineFormLabelsByGenderType,
  determineAncestorOwnershipLabels,
  determineAncestorReferenceLabel,
  determineChild,
  determineSpouse,
  determineChildByAtn,
  determineRelationshipLevel,
}
